<!-- =========================================================================================
  File Name: ClientEditTabSettings.vue
  Description: Client Edit Tab Settings page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.con-img-upload {
  background: #efeeee;
}
.custom-domain-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-wdt {
  width: 70%;
  margin-right: 15px;
}
.auth-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.button-wrap {
  text-align: right;
}
.box-wrap .vs-component.con-vs-checkbox.vs-checkbox-primary.vs-checkbox-default {padding: 15px 20px; border: 1px solid #4c8af6; border-radius: 6px;}
.active-menu-box .vs-component.con-vs-checkbox.vs-checkbox-primary.vs-checkbox-default{background: #f1f1f5;}

</style>
<template>
  <div id="client-edit-tab-settings">
    <h3 class="my-5">Features</h3>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mt-5" v-for="listItem in Features" :key="listItem.ID">
        <div class="box-wrap" :class="listItem.selected?'active-menu-box':''">
         <vs-checkbox v-model="listItem.selected" :value="listItem">{{listItem.Name}}</vs-checkbox>
        </div>
      </div>
    </div>      

      
      <div class="vx-col md:w-1-12 w-full mt-5 button-wrap">
        <vs-button class="mr-3 mb-2" @click="save_changes">Save</vs-button>
      </div>

  </div>
</template>
<script>
export default {
  components: {},
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      Features: this.data
    };
  },

  methods: {
    
    save_changes () {            

      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      this.$vs.loading()
      /* eslint-enable */
      const Id = this.$route.params.clientId
      if(Id)
      {
        this.$store.dispatch('clientManagement/updateClientFeatures', { id: Id, SelectedFeatures: this.Features})
        .then(res => { 
          this.$vs.notify({
            color: 'success',
            title: 'Client',
            text: res.message
          })
          this.$vs.loading.close()        
         }) 
        .catch(err => {     
        this.$vs.loading.close()      
          console.error(err) 
        })
      }      
    },
  }
};
</script>